<h2 class="sectionTitle"></h2>
<div class="form-container">
  <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
  <div class="form-group">
    <label for="txtCreationDateFrom">{{ 'ADMIN_USER.E_TENDER_FORM.CREATION_DATE_FROM' | translate}}</label>
    <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" #input="bsDatepicker"
      [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'>
    <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
      {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
    </div>
    <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
      {{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
    </div>
  </div>
  <div class="form-group">
    <label for="txtCreationDateTo">{{ 'ADMIN_USER.E_TENDER_FORM.CREATION_DATE_TO' | translate}}</label>
    <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" #input="bsDatepicker"
      [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'>
  </div>
  <!--Tender Type-->
  <div class="form-group">
    <label for="TenderTypeId">{{'ADMIN_USER.E_TENDER_FORM.TENDER_TYPE' | translate}}</label>
    <select id="TenderTypeId" name="TenderTypeId" class="form-control" [(ngModel)]="type">
      <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
      </option>
      <ng-container *ngFor="let tenderType of TenderTypes">
        <option *ngIf="displayedLang=='NameEN'" [value]="tenderType.Id">
          {{tenderType.NameEN}}
        </option>
        <option *ngIf="displayedLang=='NameAR'" [value]="tenderType.Id">
          {{tenderType.NameAR}}
        </option>
      </ng-container>
    </select>
  </div>
  <!--category-->
  <div class="form-group">
    <label for="category">{{'ADMIN_USER.E_TENDER_FORM.ETENDERS_CATEGORIES' | translate}}</label>
    <select id="category" name="category" class="form-control" [(ngModel)]="category">
      <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
      </option>
      <ng-container *ngFor="let tenderCategory of TenderCategories">
        <option *ngIf="displayedLang=='NameEN'" [value]="tenderCategory.Id">
          {{tenderCategory.NameEN}}
        </option>
        <option *ngIf="displayedLang=='NameAR'" [value]="tenderCategory.Id">
          {{tenderCategory.NameAR}}
        </option>
      </ng-container>
    </select>
  </div>
  <!--tenderNumber-->
  <div class="form-group">
    <label for="tenderNumber">{{ 'ADMIN_USER.E_TENDER_FORM.TENDER_NUMBER' | translate }}</label>
    <input type="text" id="tenderNumber" name="tenderNumber" class="form-control" [(ngModel)]="tenderNumber" />
  </div>
  <!--fileNumber-->
  <div class="form-group">
    <label for="fileNumber">{{ 'ADMIN_USER.E_TENDER_FORM.FILE_NUMBER' | translate }}</label>
    <input type="text" id="fileNumber" name="fileNumber" class="form-control" [(ngModel)]="fileNumber" />
  </div>
  <!--OfferDeadline-->
  <div class="form-group">
    <label for="txtOfferDeadlineFrom">{{ 'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE_FROM' | translate}}</label>
    <input class="form-control" id="txtOfferDeadlineFrom" name="txtOfferDeadlineFrom" #input="bsDatepicker"
      [(ngModel)]="offerDeadlineFrom" bsDatepicker [minDate]='null'>
    <div class="red" *ngIf="showOfferDeadlineFromDateGreaterThanToDateMessage">
      {{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
    </div>
  </div>
  <div class="form-group">
    <label for="txtOfferDeadlineTo">{{ 'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE_TO' | translate}}</label>
    <input class="form-control" id="txtOfferDeadlineTo" name="txtOfferDeadlineTo" #input="bsDatepicker"
      [(ngModel)]="offerDeadlineTo" bsDatepicker [minDate]='null'>
  </div>
  <!--tenderMethod-->
  <div class="form-group">
    <label for="tenderMethod">{{'ADMIN_USER.E_TENDER_FORM.TENDER_METHOD' | translate}}</label>
    <select id="tenderMethod" name="tenderMethod" class="form-control" [(ngModel)]="tenderMethod">
      <option [value]="undefined" selected>{{ 'ADMIN_USER.SHARED.CHOOSE' | translate }}
      </option>
      <ng-container *ngFor="let method of TenderMethods">
        <option *ngIf="displayedLang=='NameEN'" [value]="method.Id">
          {{method.NameEN}}
        </option>
        <option *ngIf="displayedLang=='NameAR'" [value]="method.Id">
          {{method.NameAR}}
        </option>
      </ng-container>
    </select>
  </div>
</div>
<div class="btns-holder text-center">
  <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadData()"
    value="{{ 'SHARED.Search' | translate}}" />
  <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetData()"
    value="{{ 'SHARED.ResetSearch' | translate}}" />
  <input type="button" class="SCAcustomBtn" *ngIf="!hideExportButton" (click)="ExportExcel()"
    value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" />
</div>
<app-grid-view #ETenderList [customMenuTemplate]="tenderTemplate" [IsHtml]="IsHtml" [HasMenu]="HasMenu"></app-grid-view>

<ng-template #tenderTemplate let-item let-menuItems="menuItems">


  <li role="menuitem" *ngIf="item.Status == ('ADMIN_USER.E_TENDER_FORM.Active'|translate) ||
                             item.Status == ('ADMIN_USER.E_TENDER_FORM.UnderStudying'|translate)||
                             item.Status == ('ADMIN_USER.E_TENDER_FORM.Created'|translate)">
    <a class="dropdown-item" (click)="Cancel(item.RequestId)">
      {{'FRONT_USER.CANCEL'|translate}}
    </a>
  </li>
  <li role="menuitem" *ngIf="(item.Status == ('ADMIN_USER.E_TENDER_FORM.Active'|translate) ||
                             item.Status == ('ADMIN_USER.E_TENDER_FORM.Created'|translate)) && 
                             (item.ETenderType == ('ADMIN_USER.E_TENDER_FORM.LIMITED_TENDER'|translate) || item.ETenderType == ('ADMIN_USER.E_TENDER_FORM.LIMITED_PRACTICE'|translate))">
    <a class="dropdown-item" (click)="InviteAdditionalSupplier(item.RequestId)">
      {{'ADMIN_USER.E_TENDER_FORM.INVITE_ADDITIONAL_SUPPLIER'|translate}}
    </a>
  </li>
  <li role="menuitem">
    <a class="dropdown-item" (click)="Edit(item.RequestId)"
      *ngIf="item.Status != ('ADMIN_USER.E_TENDER_FORM.Closed'|translate) && item.Status != ('ADMIN_USER.E_TENDER_FORM.Cancelled'|translate)">
      {{'ADMIN_USER.SHARED.EDIT'|translate}}
    </a>
    <a class="dropdown-item" (click)="Edit(item.RequestId)"
      *ngIf="item.Status == ('ADMIN_USER.E_TENDER_FORM.Closed'|translate) || item.Status == ('ADMIN_USER.E_TENDER_FORM.Cancelled'|translate)">
      {{'ADMIN_USER.SHARED.VIEW'|translate}}
    </a>
  </li>
  <li role="menuitem" *ngIf="(item.Status == ('ADMIN_USER.E_TENDER_FORM.UnderStudying'|translate) || item.Status == ('ADMIN_USER.E_TENDER_FORM.Closed'|translate))
      && item.ETenderType != ('ADMIN_USER.E_TENDER_FORM.PUBLIC_BIDDING'|translate)">
    <a class="dropdown-item" (click)="Evaluate(item.RequestId)">
      {{'ADMIN_USER.TENDER_SUPPLIERS_EVALUATION.TITLE'|translate}}
    </a>
  </li>
  <li role="menuitem"
    *ngIf="item.Status == ('ADMIN_USER.E_TENDER_FORM.UnderStudying'|translate) && item.TenderMethod == ('ADMIN_USER.E_TENDER_FORM.TWO_ENVELOPE'|translate) && item.ETenderType != ('ADMIN_USER.E_TENDER_FORM.PUBLIC_BIDDING'|translate)">
    <a class="dropdown-item" (click)="DefineDeadline(item.RequestId)">
      {{'ADMIN_USER.E_TENDER_FORM.DEFINE_TENDER_DEADLINE'|translate}}
    </a>
  </li>
  <li role="menuitem" *ngIf="item.Status == ('ADMIN_USER.E_TENDER_FORM.Cancelled'|translate)">
    <a class="dropdown-item" Confirmation (confirmationClick)="Delete(item.RequestId)">
      {{'FRONT_USER.DELETE'|translate}}
    </a>
  </li>
  <li role="menuitem">
    <a class="dropdown-item" (click)="View(item.RequestId,item.ETenderType)">
      {{'ADMIN_USER.E_TENDER_FORM.VIEW_USER_MODE'|translate}}
    </a>
  </li>
  <li role="menuitem"
  *ngIf="item.Status == ('ADMIN_USER.E_TENDER_FORM.Closed'|translate) || item.Status == ('ADMIN_USER.E_TENDER_FORM.UnderStudying'|translate)">
    <a class="dropdown-item" (click)="ViewSupplierEvaluation(item.FileNumber)">
      {{'FRONT_USER.SUPPLIER_EVALUATION.REPORT_TITLE'|translate}}
    </a>
  </li>

  <!--  <li role="menuitem">
      <a class="dropdown-item">
        hello
      </a>
  </li>
  <li role="menuitem" *ngFor="let menuItem of menuItems; let im = index;">
    <a class="dropdown-item"
      (click)="navigate(item.RequestId, item.Url, currentLanguage == 'Ar' ? menuItem.TitleAr : menuItem.Title, item.RequestNumber != null ? item.RequestNumber : '')">
      {{currentLanguage == "Ar" ? menuItem.TitleAr : menuItem.Title}}
    </a>
  </li>
  this is my custom Menu-->
</ng-template>